import { render, staticRenderFns } from "./SummaryPrice.vue?vue&type=template&id=7ef10b6f&"
import script from "./SummaryPrice.vue?vue&type=script&lang=js&"
export * from "./SummaryPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports